import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'course/';

export const getAllCourses = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};